//@flow
import React, { useCallback } from 'react';
import { Input } from 'antd';

import { FilterItem } from '../../../components';
import Field from '../../../components/card/Field';
import {
  CommonFilter,
  type FilterProps
} from '../../../components/hoc/common/handbook/CommonFilter';

import VehicleModelSelect from '../../../components/selects/VehicleModelSelect';

export type SparePartsParamsFilter = {
  search?: string,
  vehicleModelId?: number
};

export const SparePartsFilter = (
  props: FilterProps<SparePartsParamsFilter>
) => {
  const Filter = useCallback(
    (filterProps: $Shape<FilterProps<SparePartsParamsFilter>>) =>
      CommonFilter<SparePartsParamsFilter>({
        ...filterProps,
        ...props
      }),
    [props]
  );
  return (
    <Filter>
      {(values, changeValue) => (
        <>
          <FilterItem style={{ maxWidth: '350px', width: '350px' }}>
            <Field mBottomNone>
              <Input
                size="small"
                placeholder="Название или каталожный номер"
                value={values.search}
                onChange={e => changeValue('search', e.target.value)}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <VehicleModelSelect
                size="small"
                value={values.vehicleModelId}
                filter={{
                  returnDeleted: false
                }}
                onChange={(value: number) =>
                  changeValue('vehicleModelId', value)
                }
              />
            </Field>
          </FilterItem>
        </>
      )}
    </Filter>
  );
};
export default SparePartsFilter;
